module.exports = __webpack_public_path__ + "static/14-b18ca23c6b651bb2bdb97e4b230027ef.png";